import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractObjectData, BimUpdateContractSubObjectMutation } from 'gql/graphql';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback } from 'react';

import { bimUpdateContractSubObjectGql } from '../BimContractStructureRequests';

interface IUseBimUpdateContractSubObject {
    onClose: () => void;
    onSuccess: (item: BimContractObjectData) => void;
}

const requestId = 'bimUpdateContractSubObject';

export const useBimUpdateContractSubObject = (props: IUseBimUpdateContractSubObject) => {
    const { onClose, onSuccess } = props;

    const [resetBimUpdateContractSubObject] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(
        (depsVars: TActionCommonInterface<BimUpdateContractSubObjectMutation>) => {
            resetBimUpdateContractSubObject(undefined);
            if (depsVars?.payload?.bimUpdateContractSubObject?.data) {
                onSuccess(depsVars?.payload?.bimUpdateContractSubObject?.data);
            }
            onClose();
        },
        [onClose, onSuccess, resetBimUpdateContractSubObject],
    );

    const [, , , bimUpdateContractSubObjectRequest] = useRequest({
        requestId,
        query: bimUpdateContractSubObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    return bimUpdateContractSubObjectRequest;
};
